interface DeptoInterface {
  _codigo: string;
  _nombre: string;
}

interface CiudadInterface {
  _codigo: string;
  _nombre: string;
  _departamentoJoin: string | Depto ;

}

interface BarrioInterface {
  _codigo: string;
  _nombre: string;
  _ciudad: string;
  _zona: string;
  _comuna: string;
}

export class Depto implements DeptoInterface {
  _codigo = '';
  _nombre = '';

  get codigo () { return this._codigo }
  set codigo (n) { this._codigo = n }

  get nombre () { return this._nombre }
  set nombre (n) { this._nombre = n }
}

export class Ciudad implements CiudadInterface {
  _codigo = '';
  _nombre = '';
  _departamentoJoin = '';

  get codigo () { return this._codigo }
  set codigo (n) { this._codigo = n }

  get nombre () { return this._nombre }
  set nombre (n) { this._nombre = n }

  get departamentoJoin () { return this._departamentoJoin }
  set departamentoJoin (n) { this._departamentoJoin = n }
}

export class Barrio implements BarrioInterface {
  _ciudad = '';
  _zona = '';
  _comuna = '';
  _codigo = '';
  _nombre = '';

  get codigo () { return this._codigo }
  set codigo (n) { this._codigo = n }

  get nombre () { return this._nombre }
  set nombre (n) { this._nombre = n }

  get ciudad () { return this._ciudad }
  set ciudad (n) { this._ciudad = n }

  get zona () { return this._zona }
  set zona (n) { this._zona = n }

  get comuna () { return this._comuna }
  set comuna (n) { this._comuna = n }
}
